import { z } from 'zod';

/**
 * One entity that depends on a resource about to be deleted — a live agent, a
 * persona, a project, etc. Collected across the host and plugins by the
 * reference-provider registry and surfaced in delete-confirm dialogs so a
 * permanent delete is an informed one.
 *
 * `kind` is a stable discriminator the UI groups/labels by; `label` is the
 * entity's display name.
 */
export const ResourceDependentSchema = z.object({
  kind: z.string(),
  id: z.string(),
  label: z.string(),
});
export type ResourceDependent = z.infer<typeof ResourceDependentSchema>;

/** Response shape of every `.../:id/dependents` endpoint. */
export const ResourceDependentsResponseSchema = z.object({
  dependents: z.array(ResourceDependentSchema),
});
export type ResourceDependentsResponse = z.infer<typeof ResourceDependentsResponseSchema>;
